import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import css from './ListingPage.module.css';

export const TRANSLATION_NOTICE_CLOSED_KEY = 'translationNoticeClosed';

/**
 * TranslationNotice component displays a notice about automatic translations
 * with an option to close it for the current session.
 */
const TranslationNotice = ({ isVisible, onDismiss }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className={classNames(css.actionBar, css.translationNotice)}>
      <div className={css.translationNoticeContent}>
        <p className={css.translationNoticeText}>
          <FormattedMessage id="ListingPage.translationNotice" />
        </p>
        <button
          className={css.translationNoticeClose}
          onClick={onDismiss}
          aria-label="Close translation notice"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default TranslationNotice;
